import React from "react";
import styled from "styled-components";
import DatingLanding from "../components/DatingLanding";
import DiscoverPage from "./DiscoverPage";
import HowAttractionWorks from "../components/homeComponents/Howattractionworks";
import CardStackReveal from "../components/homeComponents/CardStackReveal";
import ManifestoSection from "../components/homeComponents/ManifestoSection";
import CybersecuritySection from "../components/homeComponents/Cybersecuritysection";
import AboutSection from "../components/homeComponents/AboutSection";
import FAQSection from "../components/homeComponents/FAQ";
import ContactSection from "../components/homeComponents/Contact";
import SecurityBridge from "../components/homeComponents/SecurityBridge";
import ReviewsSection from "../components/homeComponents/Reviews";
import SocialVideoSection from "../components/homeComponents/SocialVIdeoSection";

const Home = () => {
  return (
    <Container>
      <DatingLanding />
      <HowAttractionWorks />
      <CardStackReveal />
      <ManifestoSection />
      <ReviewsSection />
      <SocialVideoSection />
      <SecurityBridge />
      <CybersecuritySection />
      <AboutSection />
      <ContactSection />
      <FAQSection />
    </Container>
  );
};
const Container = styled.div`
  padding: 0;
`;

export default Home;
